module.exports = __webpack_public_path__ + "static/dark-text-bg-large-bdd958cb74ac899d1d485dbf51747b15.png";